// extracted by mini-css-extract-plugin
export default {"wrapper":"SettingsWindow-module__wrapper","header":"SettingsWindow-module__header","subheader":"SettingsWindow-module__subheader","explanation":"SettingsWindow-module__explanation"};